import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { Platform } from './pages/Platform';
import { Solutions } from './pages/Solutions';
import { Pricing } from './pages/Pricing';
import { About } from './pages/About';
import { FAQs } from './pages/FAQs';
import { Contact } from './pages/Contact';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
import { Layout } from './components/layout/Layout';
export function AppRouter() {
  return <BrowserRouter data-id="element-1">
      <Routes data-id="element-2">
        <Route path="/" element={<Layout data-id="element-4">
              <Home data-id="element-5" />
            </Layout>} data-id="element-3" />
        <Route path="/platform" element={<Layout data-id="element-7">
              <Platform data-id="element-8" />
            </Layout>} data-id="element-6" />
        <Route path="/solutions" element={<Layout data-id="element-10">
              <Solutions data-id="element-11" />
            </Layout>} data-id="element-9" />
        <Route path="/pricing" element={<Layout data-id="element-13">
              <Pricing data-id="element-14" />
            </Layout>} data-id="element-12" />
        <Route path="/about" element={<Layout data-id="element-16">
              <About data-id="element-17" />
            </Layout>} data-id="element-15" />
        <Route path="/faqs" element={<Layout data-id="element-19">
              <FAQs data-id="element-20" />
            </Layout>} data-id="element-18" />
        <Route path="/contact" element={<Layout data-id="element-22">
              <Contact data-id="element-23" />
            </Layout>} data-id="element-21" />
        <Route path="/privacy" element={<Layout data-id="element-25">
              <Privacy data-id="element-26" />
            </Layout>} data-id="element-24" />
        <Route path="/terms" element={<Layout data-id="element-28">
              <Terms data-id="element-29" />
            </Layout>} data-id="element-27" />
        <Route path="*" element={<Layout data-id="element-31">
              <Home data-id="element-32" />
            </Layout>} data-id="element-30" />
      </Routes>
    </BrowserRouter>;
}